import { action, computed } from 'mobx'
import { type DocumentManagementViewModel } from '@/features/documents/DocumentManagementViewModel'
import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'

/**
 * View model for the documents tab of a user's details.
 */
export class DocumentsTabViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  constructor(readonly documentManagementVm: DocumentManagementViewModel) {
    this._lifecycle.manage(this.documentManagementVm)
  }

  /**
   * Activates the view model.
   */
  activate() {
    this._lifecycle.activate()
  }

  /**
   * Deactivates the view model.
   */
  deactivate() {
    this._lifecycle.deactivate()
  }

  @computed
  get isSearchFilterApplied() {
    const isSearching =
      this.documentManagementVm.searcher.searchText.value !== ''
    const haveFiltersApplied =
      this.documentManagementVm.searcher.filters.appliedFilterCount > 0

    return isSearching || haveFiltersApplied
  }

  @computed
  get shouldShowEmptyState() {
    return (
      this.documentManagementVm.searcher.scroller.isDone &&
      this.documentManagementVm.searcher.documents.length === 0
    )
  }

  /**
   * Clears any search filters.
   */
  @action.bound
  clearFilters() {
    this.documentManagementVm.searcher.clearFilters()
  }
}
